module.exports = __webpack_public_path__ + "static/media/success.4eeaec47.svg";